import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { CONTEXT_ROOT } from '../../../constants';

import { scrollToAnchor } from '../../../utils';
import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import HeadComponent from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';

import './TermsPage.scss';

class TermsPage extends React.Component {
    componentDidMount() {
        scrollToAnchor(this.props.location);
    }

    componentDidUpdate() {
        scrollToAnchor(this.props.location);
    }

    render() {
        const { i18n } = this.props;

        return (
            <main className="conteneur conteneur-mobile" id="p-cgu">
                <HeadComponent
                    title={i18n.TITLE}
                    description={i18n.DESCRIPTION}
                    canonicalLink={`${CONTEXT_ROOT}${PATH.TERMS_PATH}`}
                />
                <LocalizedBreadcrumbItem to={PATH.TERMS_PATH}>
                    {i18n.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <h1>{i18n.TITLE}</h1>

                <h3>{i18n.TITLE1}</h3>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT1_1)}</p>
                <p>{i18n.TEXT1_2}</p>
                <p>{i18n.TEXT1_3}</p>
                <p>{i18n.TEXT1_4}</p>
                <p>{i18n.TEXT1_5}</p>

                <h3>{i18n.TITLE2}</h3>
                <p>{i18n.TEXT2_1}</p>
                <p>{i18n.TEXT2_2}</p>
                <p>{i18n.TEXT2_3}</p>
                <p>
                    {i18n.TEXT2_4}
                    <br></br>
                    {i18n.TEXT2_5}
                    <br></br>
                    {i18n.TEXT2_6}
                </p>
                <p>
                    {i18n.TEXT2_7}
                    <br></br>
                    {i18n.TEXT2_8}
                    <br></br>
                    {i18n.TEXT2_9}
                </p>

                <h3>{i18n.TITLE3}</h3>
                <p>{i18n.TEXT3_1}</p>
                <ul>
                    <li>{i18n.TEXT3_2}</li>
                    <li>{i18n.TEXT3_3}</li>
                </ul>
                <p>{i18n.TEXT3_4}</p>
                <p>{i18n.TEXT3_5}</p>
                <p>{i18n.TEXT3_6}</p>
                <p>{i18n.TEXT3_7}</p>
                <p>{i18n.TEXT3_8}</p>
                <p>{i18n.TEXT3_9}</p>

                <h3>{i18n.TITLE4}</h3>
                <p>{i18n.TEXT4_1}</p>
                <p>{i18n.TEXT4_2}</p>
                <p>{i18n.TEXT4_3}</p>
                <p>{i18n.TEXT4_4}</p>
                <ul>
                    <li>{i18n.TEXT4_5}</li>
                    <li>{i18n.TEXT4_6}</li>
                    <li>{i18n.TEXT4_7}</li>
                    <li>{i18n.TEXT4_8}</li>
                    <li>{i18n.TEXT4_9}</li>
                    <li>{i18n.TEXT4_10}</li>
                    <li>{i18n.TEXT4_11}</li>
                </ul>

                <h3>{i18n.TITLE5}</h3>
                <p>{i18n.TEXT5_1}</p>
                <p>{i18n.TEXT5_2}</p>

                <h3>{i18n.TITLE6}</h3>
                <p>{i18n.TEXT6_1}</p>
                <ul>
                    <li>{i18n.TEXT6_2}</li>
                    <li>{i18n.TEXT6_3}</li>
                    <li>{i18n.TEXT6_4}</li>
                    <li>{i18n.TEXT6_5}</li>
                    <li>{i18n.TEXT6_6}</li>
                    <li>{i18n.TEXT6_7}</li>
                    <li>{i18n.TEXT6_8}</li>
                </ul>
                <li>{i18n.TEXT6_9}</li>

                <h3>{i18n.TITLE7}</h3>
                <p>{i18n.TEXT7_1}</p>
                <ul>
                    <li>{i18n.TEXT7_2}</li>
                    <li>{i18n.TEXT7_3}</li>
                    <li>{i18n.TEXT7_4}</li>
                </ul>
                <p>{i18n.TEXT7_5}</p>
                <p>{i18n.TEXT7_6}</p>
                <p>{i18n.TEXT7_7}</p>
                <ul>
                    <li>{i18n.TEXT7_8}</li>
                    <li>{i18n.TEXT7_9}</li>
                    <li>{i18n.TEXT7_10}</li>
                    <li>{i18n.TEXT7_11}</li>
                    <li>{i18n.TEXT7_12}</li>
                </ul>

                <h3>{i18n.TITLE8}</h3>
                <p>{i18n.TEXT8_1}</p>
                <p>{i18n.TEXT8_2}</p>
                <p>{i18n.TEXT8_3}</p>
                <p>{i18n.TEXT8_4}</p>
                <p>{i18n.TEXT8_5}</p>
                <p>{i18n.TEXT8_6}</p>

                <h3>{i18n.TITLE9}</h3>
                <p>{i18n.TEXT9_1}</p>
                <p>{i18n.TEXT9_2}</p>
                <p>{i18n.TEXT9_3}</p>
                <p>{i18n.TEXT9_4}</p>

                <h3>{i18n.TITLE10}</h3>
                <p>{i18n.TEXT10_1}</p>
                <p>{i18n.TEXT10_2}</p>
                <p>{i18n.TEXT10_3}</p>
                <p>{i18n.TEXT10_4}</p>
                <p>{i18n.TEXT10_5}</p>
                <p>{i18n.TEXT10_6}</p>
                <p>{i18n.TEXT10_7}</p>

                <h3>{i18n.TITLE11}</h3>
                <p>{i18n.TEXT11_1}</p>
                <ul>
                    <li>{i18n.TEXT11_2}</li>
                    <li>{i18n.TEXT11_3}</li>
                    <li>{i18n.TEXT11_4}</li>
                </ul>
                <p>{i18n.TEXT11_5}</p>

                <h3>{i18n.TITLE12}</h3>
                <p>{i18n.TEXT12_1}</p>
                <p>{i18n.TEXT12_2}</p>
            </main>
        );
    }
}

TermsPage.propTypes = {
    i18n: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n.page.TERMS
    };
}

export default withTemplate(connect(mapStateToProps)(TermsPage), PrimaryTemplate);



// WEBPACK FOOTER //
// ./src/components/pages/terms/TermsPage.js